import React from 'react';
import './PaymentPage.css';

const PaymentPage = () => {
  const plans = [
    {
      title: "Starter Plan",
      price: "₹1,085",
      originalPrice: "₹3,099",
      discount: "65% OFF",
      period: "Monthly",
      features: [
        "1 Website Template",
        "Basic Customization",
        "Email Support",
        "1-year commitment required"
      ],
      popular: false
    },
    {
      title: "Professional Plan",
      price: "₹1,530",
      originalPrice: "₹5,099",
      discount: "70% OFF",
      period: "Monthly",
      features: [
        "5 Website Templates",
        "Advanced Customization",
        "Priority Support",
        "SEO Optimization",
        "6-month commitment required"
      ],
      popular: true
    },
    {
      title: "Enterprise Plan",
      price: "₹2,000",
      originalPrice: "₹7,999",
      discount: "75% OFF",
      period: "Monthly",
      features: [
        "Unlimited Templates",
        "Full Customization",
        "24/7 Dedicated Support",
        "SEO & Marketing",
        "Analytics Dashboard",
        "3-month commitment required"
      ],
      popular: false
    }
  ];

  const handlePayment = (plan) => {
    // Razorpay integration
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: plan.price.replace(/[₹,]/g, '') * 100, // Convert to paise
      currency: 'INR',
      name: 'WebDPro Solutions',
      description: `${plan.title} - Website Template Purchase`,
      image: '../webdpro.png',
      handler: function (response) {
        alert('Payment successful! Payment ID: ' + response.razorpay_payment_id);
        // Here you would typically send the payment ID to your backend for verification
      },
      prefill: {
        name: 'Customer Name',
        email: 'customer@example.com',
        contact: '9999999999'
      },
      notes: {
        plan: plan.title,
        address: 'Customer Address'
      },
      theme: {
        color: '#38bdf8'
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  return (
    <section className="payment-page">
      <div className="container">
        <div className="page-header">
          <h1 className="page-title">Choose Your Plan</h1>
          <p className="page-subtitle">Select the perfect plan for your business needs</p>
        </div>
        
        <div className="plans-container">
          <div className="plans-grid">
            {plans.map((plan, index) => (
              <div key={index} className={`plan-card glass-card ${plan.popular ? 'featured' : ''}`}>
                {plan.popular && <div className="popular-badge">Most Popular</div>}
                <div className="plan-header">
                  <h3 className="plan-title">{plan.title}</h3>
                  <div className="plan-pricing">
                    <span className="current-price">{plan.price}</span>
                    <span className="original-price">₹{plan.originalPrice}</span>
                    <span className="discount-tag">{plan.discount}</span>
                  </div>
                  <p className="plan-period">/{plan.period}</p>
                </div>
                
                <ul className="plan-features">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex}>
                      <i className="fas fa-check-circle"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <button 
                  className="glass-button plan-button"
                  onClick={() => handlePayment(plan)}
                >
                  Get Started
                </button>
              </div>
            ))}
          </div>
          
          <div className="payment-info">
            <h3>Secure Payment</h3>
            <p>All payments are processed securely through Razorpay. Your payment information is encrypted and protected.</p>
            <div className="payment-methods">
              <i className="fab fa-cc-visa"></i>
              <i className="fab fa-cc-mastercard"></i>
              <i className="fab fa-cc-amex"></i>
              <i className="fab fa-cc-paypal"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentPage;